const appConfig = {
  COUNTRY: "Zambia",
  CAPITAL: "Lusaka",
  CURRENCY: "ZMW",
  CURRENCYSYMBOL: "K ",
  EMAIL: "",
  PHONENUMBER: "+260760579796",
  WHATSAPP: "260760579796",
  FACEBOOK: "",
  INSTAGRAM: "",
  TWITTER: "",
};
export const {
  COUNTRY,
  CAPITAL,
  CURRENCY,
  CURRENCYSYMBOL,
  EMAIL,
  PHONENUMBER,
  WHATSAPP,
  FACEBOOK,
  INSTAGRAM,
  TWITTER,
} = appConfig;

export default appConfig;
